import {
  controlPaddingHorizontal,
  dropdownPaddingBlock,
} from '@atlas-frontend/design-tokens';
import styled from 'styled-components';

export const DropdownItem = styled.span`
  width: 100%;
  display: block;
  padding: ${dropdownPaddingBlock}px ${controlPaddingHorizontal}px;
`;
